import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { ServiceResponse } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { FilterType, Filter, PreviewFilter, FilterSortOrder } from './filter-administration.model';

@Injectable({
  providedIn: 'root'
})
export class FilterAdministrationService {

  constructor(
    private httpService: HttpService
  ) { }

  public getPreviewFilters(type: FilterType): Observable<PreviewFilter[]> {
    return this.httpService.postWithContext(environment.filterEndpoint, type);
  }

  public getFilter(filterId: number): Observable<Filter> {
    return this.httpService.postWithContext(environment.filterEndpoint + '/filter', filterId);
  }

  public saveFilter(filter: Filter): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.filterEndpoint + '/save', filter);
  }

  public saveSortOrder(sortorder: FilterSortOrder[]): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.filterEndpoint + '/save-sort-order', sortorder);
  }

  public deleteFilter(filterId: number): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.filterEndpoint + '/delete', filterId);
  }
}
